export const ENDPOINT = `${process.env.BACKEND_ROOT}/graphql`;

export function getWsUrl() {
  const protocol = window.location.protocol === "https:" ? "wss" : "ws";
  const hostname = window.location.hostname;
  const backendPath = process.env.BACKEND_ROOT;

  const result = `${protocol}://${hostname}${backendPath}/graphql`;

  return result;
}

const CLIENT_ABORT_ERROR_NAMES = ["TimeoutError", "AbortError"];

/**
 * Запрос оборвал сам клиент (`AbortSignal.timeout` / `abort`). Глобальный обработчик
 * такие ошибки не показывает: причину объясняет инициатор запроса.
 */
export function isClientAbortError(error: Error | null | undefined) {
  return !!error && CLIENT_ABORT_ERROR_NAMES.includes(error.name);
}
